import { skipToken, useQuery, UseQueryOptions, useSuspenseQuery } from '@tanstack/react-query';

import { IQuotesRequest } from '../../interfaces/IQuotesRequests';
import api from '../../services/api';
import { toQueryParams } from '../../utils/queryParams';

export const QUOTES_REQUESTS_QUERY_KEY = 'quotes_requests';

const getQuotesRequests = (
  personGid: string | undefined,
  leadGid: string | undefined
): Promise<{ quotes_requests: IQuotesRequest[] }> =>
  api.get(
    `/api/frontend/quotes_requests?${toQueryParams({
      person_gid: personGid,
      lead_gid: leadGid
    })}`
  );

const useQuotesRequests = ({
  personGid,
  leadGid,
  options
}: {
  personGid: string | undefined;
  leadGid: string | undefined;
  options?: Omit<UseQueryOptions<{ quotes_requests: IQuotesRequest[] }, any, IQuotesRequest[], any>, 'queryKey'>;
}) =>
  useQuery({
    queryKey: [QUOTES_REQUESTS_QUERY_KEY, personGid, leadGid],
    queryFn: personGid ? () => getQuotesRequests(personGid, leadGid) : skipToken,
    select: data => data.quotes_requests,
    ...options
  });

export const useSuspenseQuotesRequests = ({
  personGid,
  leadGid,
  enabled
}: {
  personGid: string | undefined;
  leadGid: string | undefined;
  enabled: boolean;
}) =>
  useSuspenseQuery({
    queryKey: [QUOTES_REQUESTS_QUERY_KEY, personGid, leadGid, enabled],
    queryFn: () => (enabled ? getQuotesRequests(personGid, leadGid) : Promise.resolve({ quotes_requests: [] })),
    select: data => data.quotes_requests,
    staleTime: 10_000
  });

export default useQuotesRequests;
